{
  "title": "Hangars vergleichen",
  "buttons": {
    "stack": "Stapel"
  },
  "resultGrid": {
    "columns": {
      "hangar": "Hangar",
      "progress": "Fortschritt",
      "variants": "# Varianten",
      "placed": "# Platziert",
      "duration": "Dauer",
      "utilization": "Auslastung",
      "topUtilizations": "Top 4 Auslastungen",
      "viewResults": "Ergebnisse zeigen"
    }
  }
}
